import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store/index";

Vue.use(VueRouter);

export const routes = [{
    path: "/",
    name: "Home",
    component: () =>
        import ( /* webpackChunkName: "home" */ "@/views/Home.vue"),
    meta: {
        title: "Home",
        icon: "home",
        requiresAuth: true,
        hiddenInNav: false,
        breadcrumbDisabled: false,
        id: 1,
    },
}, ];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

// eslint-disable-next-line
router.beforeEach(async(to, from, next) => {
    const isAuthenticated = await store.dispatch("checkSessionValid");

    if (!isAuthenticated && to.name !== "Home") {
        return await store.dispatch("logout");
    }
    return next();
});
export default router;